import React from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import { Container } from "react-bootstrap";
import { usePageContent } from "../hooks/usePageContent";

function CookiePolicy() {
  const { content, loading, error } = usePageContent("cookie-policy");

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <>
      <div className="main pp-tc-page">
        <Header />
        <CommonBanner title="Cookie Policy" />
        <section className="pp-tc-section common-padding">
          <Container>
            {loading && <p>Loading content...</p>}
            {error && <p className="text-danger">{error}</p>}
            {!loading && !error && (<div
              className="page-content"
              dangerouslySetInnerHTML={{ __html: content?.page_description || "<p>No content available.</p>" }}
            />)}

          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default CookiePolicy;
